import BaseService from './base.service';

export default class SelfHelpCategoryService extends BaseService {
  getCategories() {
    return this.get('/self-help-category');
  }
}
